import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Button from '../common/Button'

const cakeImages = [
  { src: '/images/rabri-jalebi-cake.jpeg', alt: 'Rabri Jalebi cake' },
  { src: '/images/tiramisu-cake.jpeg', alt: 'Tiramisu cake' },
  { src: '/images/vanilla-cake.jpeg', alt: 'Vanilla cake' },
  { src: '/images/rasmalai-cake.jpeg', alt: 'Rasmalai fusion cake' },
  { src: '/images/white-forest-cake.jpeg', alt: 'White Forest cake' },
  { src: '/images/gulabjamun-cake.jpeg', alt: 'Gulab Jamun cake' },
  { src: '/images/chocolate-cake.jpeg', alt: 'Dark chocolate cake' },
  { src: '/images/black-forest-cake.jpeg', alt: 'Black Forest cake' },
]

function Hero() {
  const [index, setIndex] = useState(0)

  // Auto-advance the photo every 4 seconds.
  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % cakeImages.length), 4000)
    return () => clearInterval(timer)
  }, [])

  return (
    <section className="bg-cream overflow-hidden">
      <div className="container mx-auto px-4 pt-6 pb-10 md:pt-14 md:pb-16 lg:pt-20 lg:pb-24">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center max-w-6xl mx-auto">
          {/* Copy */}
          <div className="lg:col-span-7 flex flex-col gap-5 md:gap-7 animate-fadeIn">
            <h1 className="text-[40px] sm:text-5xl md:text-6xl lg:text-7xl leading-[1.08] font-heading font-bold text-charcoal tracking-tight pb-1">
              Where every slice tells a <em className="italic text-coral-500">story</em>
            </h1>
            <p className="text-base md:text-xl text-gray-700 leading-relaxed max-w-xl">
              Fresh cream cakes and cupcakes, baked from scratch in Hoofddorp. Indian fusion and classic flavours, eggless on request.
            </p>
            <div className="flex gap-3">
              <Button to="/cake-builder" className="flex-1 sm:flex-none shadow-coral">Order a cake</Button>
              <Button to="/menu" variant="secondary" className="flex-1 sm:flex-none bg-white/60">See the menu</Button>
            </div>
            <Link to="/taart-bestellen-hoofddorp" lang="nl" className="text-sm text-gray-600 hover:text-coral-600 underline underline-offset-4 self-start">
              Nederlands? Taart bestellen in Hoofddorp
            </Link>
          </div>

          {/* Photo */}
          <div className="lg:col-span-5 relative mt-2 lg:mt-0">
            <div className="absolute inset-0 bg-coral-500 rounded-3xl rotate-3" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-3xl shadow-2xl h-[300px] sm:h-[420px] lg:h-[550px]">
              {cakeImages.map((image, i) => (
                <img
                  key={image.src}
                  src={image.src}
                  alt={image.alt}
                  loading={i === 0 ? 'eager' : 'lazy'}
                  fetchPriority={i === 0 ? 'high' : 'auto'}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${i === index ? 'opacity-100' : 'opacity-0'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
